import '../JobQueue/JobQueue.scss';

import FilterListIcon from '@mui/icons-material/FilterList';
import { TablePagination, Typography } from '@mui/material';
import { CandidateSubmissionType } from 'components/JobQueue/utils';
import React, { useState } from 'react';

import CandidateTableHeader from './MoreCandidateHeader';
import CandidateTable from './MoreCandidateTables';

const MoreCandidate: React.FC<{
  goBack: () => void;
  matchesList: CandidateSubmissionType[];
}> = ({ goBack, matchesList }) => {
  const [searchValue, setSearchValue] = useState('');
  const [selectedRows, setSelectedRows] = useState<string[]>([]);

  const [, setOpenFilter] = useState(false);
  const [loading] = React.useState<any>(false);
  const [params, setParams] = React.useState<any>({
    search: '',
    skip: 0,
    take: 50,
  });
  const [tableInfo] = React.useState<any>({
    list: [],
    total: 0,
  });

  const handleSearchChange = (value: string) => {
    setSearchValue(value);
    setParams((prev) => ({
      ...prev,
      skip: 0,
      take: prev.take,
    }));
  };

  const handleRowSelect = (id: string) => {
    setSelectedRows((prev) => {
      if (prev.includes(id)) {
        return prev.filter((rowId) => rowId !== id);
      } else {
        return [...prev, id];
      }
    });
    console.log('Selected rows:', selectedRows, id);
  };

  const handleSelectAll = (selected: boolean) => {
    if (selected) {
      // Select all visible rows (you might want to implement select all across all pages)
      setSelectedRows([]);
    } else {
      setSelectedRows([]);
    }
  };

  const handlePageChange = (
    event: React.MouseEvent<HTMLButtonElement> | null,
    newPage: number,
  ) => {
    setParams((prev) => ({
      ...prev,
      skip: newPage * Number(prev.take),
    }));
  };

  const handleChangeRowsPerPage = (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
  ) => {
    setParams((prev) => ({
      ...prev,
      skip: 0,
      take: parseInt(event.target.value, 10),
    }));
  };

  console.log('Render ');
  return (
    <Typography component={'div'} className="job-queue-container">
      {/* Header Component */}
      <CandidateTableHeader
        searchValue={searchValue}
        onSearchChange={handleSearchChange}
        goBack={() => goBack()}
      />

      {/* Table Component */}
      <div className="job-queue-table-container">
        <div className="job-queue-table-container-content">
          <div className="job-queue-table-container-tabs">
            <CandidateTable
              users={matchesList || []}
              selectedRows={selectedRows}
              onRowSelect={handleRowSelect}
              onSelectAll={handleSelectAll}
              loading={loading}
            />
          </div>

          <div
            className="job-queue-table-container-filters"
            onClick={() => setOpenFilter(true)}>
            <FilterListIcon />
            <Typography
              component="div"
              sx={{
                color: '#181D1F',
                fontFamily: 'Red Hat Display Regular',
                fontSize: '13px',
                fontWeight: 400,
                rotate: '90deg',
              }}>
              Filters
            </Typography>
          </div>
        </div>

        {/* Pagination Component */}
        <div className="job-queue-pagination-container">
          <TablePagination
            sx={{
              '& .MuiTablePagination-select': {
                fontFamily: 'Red Hat Display Medium !important',
              },
              '& p': {
                fontFamily: 'Red Hat Display Medium !important',
              },
            }}
            component="div"
            count={tableInfo?.total || 0}
            page={Number(params.skip) / Number(params.take)}
            onPageChange={handlePageChange}
            rowsPerPage={params.take ? parseInt(params.take) : 0}
            rowsPerPageOptions={[50, 100, 150, 200, 250]}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </div>
      </div>
    </Typography>
  );
};

export default MoreCandidate;
